"use strict";

var _slicedToArray = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));

var react_1 = require("react");

function useComponentSize(ref) {
  var _react_1$useState = react_1.useState({
    width: 0,
    height: 0
  }),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      size = _react_1$useState2[0],
      setSize = _react_1$useState2[1];

  react_1.useEffect(function () {
    var sizeObserver = new resize_observer_polyfill_1.default(function (entries) {
      entries.forEach(function (_ref) {
        var target = _ref.target;

        if (size.width !== target.clientWidth || size.height !== target.clientHeight) {
          setSize({
            width: target.clientWidth,
            height: target.clientHeight
          });
        }
      });
    });
    sizeObserver.observe(ref.current);
    return function () {
      return sizeObserver.disconnect();
    };
  }, [ref]);
  return size;
}

exports.default = useComponentSize;